import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { BaseChartDirective } from 'ng2-charts';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';
import { VorModel } from '../pages/P&A/vor/vor.model';
import { ServicoService } from '../pages/status/servico/servico-service/servico.service';
import { VorService } from './../pages/P&A/vor/vor.service';
import { ConversaoLibraConverte } from './../shared/conversao-libra/conversao-libra-converte';
import { Filtros } from './../shared/crud/Filtro/Filtros';
import { DashBoard } from './../shared/dashboard';
import { FormatarData } from './../shared/formatarData';
import { HomeService } from './home-service/home.service';
import { ServiceAppService } from '../security/service-app.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['home.component.css']
})

export class HomeComponent implements OnInit {
  chartQuantidadeAberturaOSHovered: any;
  chartQuantidadeAberturaOSClicked: any;
  chartValorAberturaOSHovered: any;
  chartValorAberturaOSClicked: any;
  chartQuantidadeFechamentoOSHovered: any;
  chartQuantidadeFechamentoOSClicked: any;
  chartValorFechamentoOSHovered: any;
  chartValorFechamentoOSClicked: any;
  pulseButton: any;

  carregando: boolean;
  resolucaoTelaGrafico = screen.availWidth; // recebe o valor do tamanho da tela, assim ira apresentar no grafico de O.S. por dia.
  filtroMarcas = [];
  index: number[] = [];
  valor: number[] = [];
  valueOsStopped: number = 0
  quantidade: number[] = [];
  quant: number[] = [];
  dados: any = {};
  data: VorModel[];
  servicoDados: any[];
  state$: Observable<object>;
  subscription;
  public innerWidth: any;
  public mensagem: any = [];
  public dealersInativos: boolean = false;

  configShowNumber = {
    animation: 'count',
    format: '(.ddd),dd'
  };

  // Propriedades para animação dos valores
  animatedValues = {
    valorPecas: 0,
    valorMaoObra: 0,
    valorAcessorios: 0,
    valor_os_fechada: 0,
    valor_os_aberta: 0,
    valueOsStopped: 0
  };

  arrayTranslateChart = [{ categoria: "Peças", chave: "home.chartLabels.pecas" },
  { categoria: "Mão de Obra", chave: "home.chartLabels.maoObra" },
  { categoria: "Acessórios", chave: "home.chartLabels.acessorios" }
  ];

  arrayTranslateChartDataSet = [{ categoria: "Mês Anterior", chave: "home.chartLabels.mesAnterior" },
  { categoria: "Mês Atual", chave: "home.chartLabels.mesAtual" }
  ];

  @ViewChild('chartValores') chartValores: BaseChartDirective;
  public chartValoresOptions: any = { responsive: true, legend: { position: 'left' } }; // maintainAspectRatio: false,
  public chartValoresLabels: string[] = ['Peças (0%)', 'Mão de Obra (0%)', 'Acessórios (0%)'];
  public chartValoresData: any[] = [{ data: [0, 0, 0], backgroundColor: ['#4353c0', '#7CA1D3', '#007bff'] }];
  public chartValoresType = 'pie';
  public chartValoresLegend = true;

  @ViewChild('chartQuantidadeAberturaOS') chartQuantidadeAberturaOS: BaseChartDirective;
  public chartQuantidadeAberturaOSOptions: any = {
    responsive: true, scaleShowVerticalLines: false, tickMarkLength: 2000, stacked: true,
    legend: { position: 'top' }
  };
  public chartQuantidadeAberturaOSLabels: string[] = [];
  public chartQuantidadeAberturaOSType = 'line';
  public chartQuantidadeAberturaOSLegend = true;
  public chartQuantidadeAberturaOSData: any[] = [{ data: [], label: 'Mês Anterior' }, { data: [], label: 'Mês Atual' }];
  public chartQuantidadeAberturaOSPlugins: any;

  @ViewChild('chartValorAberturaOS') chartValorAberturaOS: BaseChartDirective;
  public chartValorAberturaOSOptions: any = { responsive: true, scaleShowVerticalLines: true, legend: { position: 'top' } };
  public chartValorAberturaOSLabels: string[] = [];
  public chartValorAberturaOSType = 'line';
  public chartValorAberturaOSLegend = true;
  public chartValorAberturaOSData: any[] = [{ data: [], label: 'Mês Anterior' }, { data: [], label: 'Mês Atual' }];
  public chartValorAberturaOSPlugins: any;

  @ViewChild('chartQuantidadeFechamentoOS') chartQuantidadeFechamentoOS: BaseChartDirective;
  public chartQuantidadeFechamentoOSOptions: any = { responsive: true, scaleShowVerticalLines: true, legend: { position: 'top' } };
  public chartQuantidadeFechamentoOSLabels: string[] = [];
  public chartQuantidadeFechamentoOSType = 'line';
  public chartQuantidadeFechamentoOSLegend = true;
  public chartQuantidadeFechamentoOSData: any[] = [{ data: [], label: 'Mês Anterior' }, { data: [], label: 'Mês Atual' }];
  public chartQuantidadeFechamentoOSPlugins: any;

  @ViewChild('chartValorFechamentoOS') chartValorFechamentoOS: BaseChartDirective;
  public chartValorFechamentoOSOptions: any = { responsive: true, scaleShowVerticalLines: true, legend: { position: 'top' } };
  public chartValorFechamentoOSLabels: string[] = [];
  public chartValorFechamentoOSType = 'line';
  public chartValorFechamentoOSLegend = true;
  public chartValorFechamentoOSData: any[] = [{ data: [], label: 'Mês Anterior' }, { data: [], label: 'Mês Atual' }];
  public chartValorFechamentoOSPlugins: any;

  constructor(private servico: HomeService,
    private serviceClient: ServiceAppService,
    private dash: DashBoard,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private vorService: VorService,
    private servicoService: ServicoService,
    private router: Router) {

    this.getTranslateChartLine();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.resolucaoTelaGrafico = event.target.innerWidth;
  }

  ngOnInit() {
    this.atualizarFiltroMarcas();
    this.getOsStopped();
    this.getDealersServiceInative();
    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translateService.onLangChange
      .subscribe((_event: LangChangeEvent) => {
        this.atualizarFiltroMarcas();
      });
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  atualizarFiltroMarcas() {
    this.carregando = true;
    let promise: Promise<any>;

    promise = this.servico.getFiltroMarcas()

    promise
      .then(r => {
        this.preencherFiltroMarcas(r.dados);

        const m = [];

        this.filtroMarcas.forEach(element => {
          if (element.selecionado) {
            m.push(element.id);
          }
        });

        const marcas = { marcas: m };
        this.atualizarTotais(marcas);
      })
      .catch(error => this.tratarErro('Não foi possível retornar dados.', 'Erro', error));
  }

  atualizarTotais(marcas: object) {
    this.servico.getTotais(marcas)
      .then(r => {
        r.percentual_acessorios = this.conversaoLibraConverte.conversaoLibra(r.percentual_acessorios, null, null);
        r.percentual_mao_obra = this.conversaoLibraConverte.conversaoLibra(r.percentual_mao_obra, null, null);
        r.percentual_pecas = this.conversaoLibraConverte.conversaoLibra(r.percentual_pecas, null, null);
        r.total = this.conversaoLibraConverte.conversaoLibra(r.total, null, null);
        r.valorAcessorios = this.conversaoLibraConverte.conversaoLibra(r.valorAcessorios, null, null);
        r.valorMaoObra = this.conversaoLibraConverte.conversaoLibra(r.valorMaoObra, null, null);
        r.valorPecas = this.conversaoLibraConverte.conversaoLibra(r.valorPecas, null, null);
        r.valor_os_aberta = this.conversaoLibraConverte.conversaoLibra(r.valor_os_aberta, null, null);
        r.valor_os_fechada = this.conversaoLibraConverte.conversaoLibra(r.valor_os_fechada, null, null);

        this.preencherTotais(r);
        this.buscarAberturasOs(marcas);
        this.buscarFechamentosOs(marcas);
        this.getDealersServiceInative();
      });


  }

  buscarAberturasOs(marcas: object) {
    this.dados.periodo.inicio = this.dados.periodo.inicio.substring(0, 10);
    this.dados.periodo.fim = this.dados.periodo.fim.substring(0, 10);
    let dataIniMesAtual = this.dados.periodo.inicio.substring(0, 10);
    let dataFimMesAtual = this.dados.periodo.fim.substring(0, 10);

    let dataIniMesAtual1 = dataIniMesAtual.split('-');
    let dataFimMesAtual1 = dataFimMesAtual.split('-');

    let dataIniMesAnterior = new Date(dataIniMesAtual1[0], dataIniMesAtual1[1], dataIniMesAtual1[2], 0, 0, 0);
    let dataFimMesAnterior = new Date(dataFimMesAtual1[0], dataFimMesAtual1[1], dataFimMesAtual1[2], 0, 0, 0);

    const diaMesAtual = dataFimMesAnterior.getDate();
    let mesAtual = dataFimMesAnterior.getMonth();
    let anoAtual = dataFimMesAnterior.getFullYear();

    dataIniMesAnterior.setMonth(dataIniMesAnterior.getMonth() - 2);
    dataFimMesAnterior.setMonth(dataFimMesAnterior.getMonth() - 2);

    this.servico.getAberturasOS(dataIniMesAtual, dataFimMesAtual, marcas)
      .then(r => {
        const aberturasMesAtual = r.dados;

        let formatarData: FormatarData;
        formatarData = new FormatarData(0, 0, 0, 0, 0, 0);

        formatarData.setData(dataIniMesAnterior);
        let strDataIniMesAnterior: string;
        strDataIniMesAnterior = formatarData.getDataString();

        formatarData.setData(dataFimMesAnterior);
        let strDataFimMesAnterior: string;

        if (diaMesAtual > this.getDaysInMonth(mesAtual - 1, anoAtual)) {
          if (mesAtual === 0) {
            anoAtual = anoAtual - 1;
            mesAtual = 11;
          } else {
            mesAtual = mesAtual - 1;
          }
          const x = new FormatarData(anoAtual, mesAtual + 1, this.getDaysInMonth(mesAtual, anoAtual), 0, 0, 0);
          strDataFimMesAnterior = x.getDataString();
        } else {

          strDataFimMesAnterior = formatarData.getDataString();
        }

        this.servico.getAberturasOS(strDataIniMesAnterior, strDataFimMesAnterior, marcas)
          .then(s => {
            const aberturasMesAnterior = s.dados;

            this.preencherAberturasOsMesAtual(aberturasMesAtual);
            this.preencherAberturasOsMesAnterior(aberturasMesAnterior);
          });
      });
  }

  getDaysInMonth(month: number, year: number): number {
    return new Date(year, month + 1, 0).getDate();

  }

  limparArrayLabelQtdAbertura() {
    this.chartQuantidadeAberturaOSLabels = [];
  }

  getLabelsFormatados(dados: any): any {
    let mesDiferente = false;
    let mesAnterior = 0;

    dados.forEach(e => {
      const dia = new Date(e.data).getDate();
      const mes = new Date(e.data).getMonth() + 1;

      if (mesAnterior !== 0 && mesAnterior !== mes) {
        mesDiferente = true;
      }

      e.dia = ((dia < 10) ? '0' + dia.toString() : dia.toString());
      e.mes = ((mes < 10) ? '0' + mes.toString() : mes.toString());
      mesAnterior = mes;
    });

    const retorno = [];
    dados.forEach(e => {
      if (mesDiferente) {
        retorno.push(e.dia + '/' + e.mes);
      } else {
        retorno.push(e.dia);
      }
    });

    return retorno;
  }

  preencherArrayLabelQtdAbertura(labels: any) {
    labels.forEach(e => {
      this.chartQuantidadeAberturaOSLabels.push(e);
    });

  }

  atualizarAberturasOS(marcas: object) {
    this.servico.getAberturasOS(this.dados.periodo.inicio, this.dados.periodo.fim, marcas)
      .then(r => { this.preencherAberturasOsMesAtual(r.dados); });
  }

  buscarFechamentosOs(marcas: object) {
    let dataIniMesAtual = this.dados.periodo.inicio.substring(0, 10);
    let dataFimMesAtual = this.dados.periodo.fim.substring(0, 10);

    let dataIniMesAtual1 = dataIniMesAtual.split('-');
    let dataFimMesAtual1 = dataFimMesAtual.split('-');

    let dataIniMesAnterior = new Date(dataIniMesAtual1[0], dataIniMesAtual1[1], dataIniMesAtual1[2], 0, 0, 0);
    let dataFimMesAnterior = new Date(dataFimMesAtual1[0], dataFimMesAtual1[1], dataFimMesAtual1[2], 0, 0, 0);

    const diaMesAtual = dataFimMesAnterior.getDate();
    let mesAtual = dataFimMesAnterior.getMonth();
    let anoAtual = dataFimMesAnterior.getFullYear();

    dataIniMesAnterior.setMonth(dataIniMesAnterior.getMonth() - 2);
    dataFimMesAnterior.setMonth(dataFimMesAnterior.getMonth() - 2);

    this.servico.getFechamentosOS(dataIniMesAtual, dataFimMesAtual, marcas)
      .then(r => {
        const fechamentosMesAtual = r.dados;

        let formatarData: FormatarData;
        formatarData = new FormatarData(0, 0, 0, 0, 0, 0);

        formatarData.setData(dataIniMesAnterior);
        let strDataIniMesAnterior: string;
        strDataIniMesAnterior = formatarData.getDataString();

        formatarData.setData(dataFimMesAnterior);
        let strDataFimMesAnterior: string;

        if (diaMesAtual > this.getDaysInMonthFechamento(mesAtual - 1, anoAtual)) {
          if (mesAtual === 0) {
            anoAtual = anoAtual - 1;
            mesAtual = 11;
          } else {
            mesAtual = mesAtual - 1;
          }
          const x = new FormatarData(anoAtual, mesAtual + 1, this.getDaysInMonthFechamento(mesAtual, anoAtual), 0, 0, 0);
          strDataFimMesAnterior = x.getDataString();
        } else {

          strDataFimMesAnterior = formatarData.getDataString();
        }

        this.servico.getFechamentosOS(strDataIniMesAnterior, strDataFimMesAnterior, marcas)
          .then(s => {
            const fechamentosMesAnterior = s.dados;

            this.preencherFechamentosOsMesAtual(fechamentosMesAtual);
            this.preencherFechamentosOsMesAnterior(fechamentosMesAnterior);
          });
      });
  }

  getDaysInMonthFechamento(month: number, year: number): number {
    return new Date(year, month + 1, 0).getDate();
  }

  limparArrayLabelQtdFechamento() {
    this.chartQuantidadeFechamentoOSLabels = [];
  }

  getLabelsFormatadosFechamento(dados: any): any {
    let mesDiferente = false;
    let mesAnterior = 0;

    dados.forEach(e => {
      const dia = new Date(e.data).getDate();
      const mes = new Date(e.data).getMonth() + 1;
      e.dia += e.dia - 15;
      if (mesAnterior !== 0 && mesAnterior !== mes) {
        mesDiferente = true;
      }
      e.dia = ((dia < 10) ? '0' + dia.toString() : dia.toString());
      e.mes = ((mes < 10) ? '0' + mes.toString() : mes.toString());
      mesAnterior = mes;
    });


    const retorno = [];
    dados.forEach(e => {
      if (mesDiferente) {
        retorno.push(e.dia + '/' + e.mes);
      } else {
        retorno.push(e.dia);
      }
    });

    return retorno;
  }

  preencherArrayLabelQtdFechamento(labels: any) {
    labels.forEach(e => {
      this.chartQuantidadeFechamentoOSLabels.push(e);
    });

  }

  atualizarFechamentosOS(marcas: object) {
    this.servico.getFechamentosOS(this.dados.periodo.inicio, this.dados.periodo.fim, marcas)
      .then(r => { this.preencherFechamentosOsMesAtual(r.dados); });
  }

  preencherFiltroMarcas(dados: any) {
    this.filtroMarcas.forEach(marca => {
      const i: number = dados.map(m => m.id).indexOf(marca.id);
      if (i < 0) {
        this.filtroMarcas.splice(marca);
      }
    });

    dados.forEach(marca => {
      const i: number = this.filtroMarcas.map(m => m.id).indexOf(marca.id);
      if (i < 0) {
        marca.selecionado = true;
        this.filtroMarcas.push(marca);
      }
    });

  }

  preencherTotais(dados: any) {
    this.prepararDados(dados);
    this.dados = dados;
    this.preencherChartValores(dados);
    this.getTranslateChartPie(dados);
    this.getOsStopped();
    
    // Inicia animações dos valores principais
    setTimeout(() => {
      this.animateValue('valorPecas', dados.valorPecas, 1000);
      this.animateValue('valorMaoObra', dados.valorMaoObra, 1000);
      this.animateValue('valorAcessorios', dados.valorAcessorios, 1000);
    }, 100);
  }

  preencherAberturasOsMesAtual(dados: any) {
    let mesAnterior = 0;
    this.dados.valor_os_aberta = 0
    this.dados.quantidade_os_aberta = 0
    dados.forEach(e => {

      let datadia = e.data.substring(0, 10).split('-');
      let datames = e.data.substring(0, 10).split('-');

      let dia = new Date(datadia[0], datadia[1], datadia[2], 0, 0, 0).getDate();
      let mes = new Date(datames[0], datames[1], datames[2], 0, 0, 0).getMonth() + 1;

      if (mesAnterior !== 0 && mesAnterior !== mes) {
      }

      this.dados.quantidade_os_aberta += e.quantidade;
      this.dados.valor_os_aberta += e.valor;

      if (dia < 25) {
        e.quantidade_mes_anterior = 1500;
        e.valor_mes_anterior = e.valor + 50;
      } else {
        e.quantidade_mes_anterior = null;
        e.valor_mes_anterior = e.valor + 50;
      }

      e.dia = ((dia < 10) ? '0' + dia.toString() : dia.toString());
      e.mes = ((mes < 10) ? '0' + mes.toString() : mes.toString());
      mesAnterior = mes;
    });

    this.dados.valor_os_aberta = this.conversaoLibraConverte.conversaoLibra(this.dados.valor_os_aberta, null, null);

    this.chartQuantidadeAberturaOSLabels = dados.map(e => e.dia);
    this.chartValorAberturaOSLabels = dados.map(e => e.dia);
    this.chartQuantidadeAberturaOSData[1].data = dados.map(e => e.quantidade);
    this.chartValorAberturaOSData[1].data = dados.map(e => this.conversaoLibraConverte.conversaoLibra(e.valor, null, null));
    
    // Anima valor OS aberta
    setTimeout(() => {
      this.animateValue('valor_os_aberta', this.dados.valor_os_aberta, 1000);
    }, 200);
  }

  preencherAberturasOsMesAnterior(dados: any) {
    this.chartQuantidadeAberturaOSData[0].data = dados.map(e => e.quantidade);
    this.dash.reloadChart(false, this.chartQuantidadeAberturaOS);

    this.chartValorAberturaOSData[0].data = dados.map(e => this.conversaoLibraConverte.conversaoLibra(e.valor, null, null));
    this.dash.reloadChart(false, this.chartValorAberturaOS);
  }

  preencherFechamentosOsMesAtual(dados: any) {
    this.carregando = true
    let mesDiferente = false;
    let mesAnterior = 0;
    this.dados.valor_os_fechada = 0;
    this.dados.quantidade_os_fechada = 0;

    dados.forEach(f => {

      let datadia = f.data.substring(0, 10).split('-');
      let datames = f.data.substring(0, 10).split('-');

      let dia = new Date(datadia[0], datadia[1], datadia[2], 0, 0, 0).getDate();
      let mes = new Date(datames[0], datames[1], datames[2], 0, 0, 0).getMonth() + 1;

      if (mesAnterior !== 0 && mesAnterior !== mes) {
        mesDiferente = false;
      }

      this.dados.quantidade_os_fechada += f.quantidade;
      this.dados.valor_os_fechada += f.valor;

      f.dia = ((dia < 10) ? '0' + dia.toString() : dia.toString());
      f.mes = ((mes < 10) ? '0' + mes.toString() : mes.toString());
      mesAnterior = mes;

    });

    this.dados.valor_os_fechada = this.conversaoLibraConverte.conversaoLibra(this.dados.valor_os_fechada, null, null);

    if (mesDiferente) {
      this.chartQuantidadeFechamentoOSLabels = dados.map(f => f.dia + '/' + f.mes);
      this.chartValorFechamentoOSLabels = dados.map(f => f.dia + '/' + f.mes);
    } else {
      this.chartQuantidadeFechamentoOSLabels = dados.map(f => f.dia);
      this.chartValorFechamentoOSLabels = dados.map(f => f.dia);
    }

    this.chartQuantidadeFechamentoOSData[1].data = dados.map(f => f.quantidade); // quantidade
    this.dash.reloadChart(false, this.chartQuantidadeFechamentoOS);

    this.chartValorFechamentoOSData[1].data = dados.map(f => this.conversaoLibraConverte.conversaoLibra(f.valor, null, null));  // valor
    this.dash.reloadChart(false, this.chartValorFechamentoOS)
    this.carregando = false
    
    // Anima valor OS fechada
    setTimeout(() => {
      this.animateValue('valor_os_fechada', this.dados.valor_os_fechada, 2000);
    }, 300);
  }

  // fechamento de ordens de serviço "mes Anterior quantidade e valor"
  preencherFechamentosOsMesAnterior(dados: any) {

    this.chartQuantidadeFechamentoOSData[0].data = dados.map(f => f.quantidade); // quanidade
    this.dash.reloadChart(false, this.chartQuantidadeFechamentoOS);

    this.chartValorFechamentoOSData[0].data = dados.map(f => this.conversaoLibraConverte.conversaoLibra(f.valor, null, null));          // valor
    this.dash.reloadChart(false, this.chartValorFechamentoOS);
  }

  prepararDados(dados: any) {
    dados.quantidade_os_aberta = 0;
    dados.valor_os_aberta = 0;
    dados.quantidade_os_fechada = 0;
    dados.valor_os_fechada = 0;
    dados.total = dados.valorPecas + dados.valorMaoObra + dados.valorAcessorios;

    if (dados.total > 0) {
      dados.percentual_pecas = dados.valorPecas / dados.total * 100;
      dados.percentual_mao_obra = dados.valorMaoObra / dados.total * 100;
      dados.percentual_acessorios = dados.valorAcessorios / dados.total * 100;
    } else {
      dados.percentual_pecas = 0;
      dados.percentual_mao_obra = 0;
      dados.percentual_acessorios = 0;
    }

  }

  preencherChartValores(dados: any) {
    let valor0: number;
    let valor1: number;
    let valor2: number;
    if (this.translateService.currentLang == 'br') {
      this.chartValoresLabels[0] = 'Peças: (' + Math.round(dados.percentual_pecas) + '%)';
      this.chartValoresLabels[1] = 'Mão de Obra: (' + Math.round((dados.percentual_mao_obra * 100) / 100) + '%)';
      this.chartValoresLabels[2] = 'Acessórios: (' + Math.round((this.dados.percentual_acessorios * 100) / 100) + '%)';
    } else {
      this.chartValoresLabels[0] = 'Parts: (' + Math.round(dados.percentual_pecas) + '%)';
      this.chartValoresLabels[1] = 'Labor: (' + Math.round((dados.percentual_mao_obra * 100) / 100) + '%)';
      this.chartValoresLabels[2] = 'Acessories: (' + Math.round((this.dados.percentual_acessorios * 100) / 100) + '%)';
    }


    valor0 = dados.percentual_pecas;
    valor1 = dados.percentual_mao_obra;
    valor2 = this.dados.percentual_acessorios;

    this.chartValoresData[0].data[0] = valor0.toFixed(2);
    this.chartValoresData[0].data[1] = valor1.toFixed(2);
    this.chartValoresData[0].data[2] = valor2.toFixed(2);


    this.dash.reloadChart(true, this.chartValores);
  }

  marcar(marca) {
    marca.selecionado = !marca.selecionado;
  }
  tratarErro(mensagem: string, titulo: string, error: any) {
    this.carregando = false;
    console.error(error);
    this.toastr.error(mensagem, titulo);
  }

  private getTranslateChartPie(dados) {
    let valor0: number;
    let valor1: number;
    let valor2: number;

    valor0 = Math.round(dados.percentual_pecas);
    valor1 = Math.round(dados.percentual_mao_obra);
    valor2 = Math.round(dados.percentual_acessorios);

    if (this.translateService.currentLang == "br") {
      this.chartValoresLabels[0] = "Peças: " + '(' + valor0.toFixed(0) + '%)';
      this.chartValoresLabels[1] = "Mão de Obra: " + '(' + valor1.toFixed(0) + '%)';
      this.chartValoresLabels[2] = "Acessórios: " + '(' + valor2.toFixed(0) + '%)';
    }

    if (this.translateService.currentLang == "gb") {
      this.chartValoresLabels[0] = "Parts: " + '(' + valor0.toFixed(0) + '%)';
      this.chartValoresLabels[1] = "Labor: " + '(' + valor1.toFixed(0) + '%)';
      this.chartValoresLabels[2] = "Acessories: " + '(' + valor2.toFixed(0) + '%)';
    }
  }

  private getOsStopped() {
    let objFiltro: Filtros = new Filtros();
    this.vorService.buscar(objFiltro).then(res => {
      this.data = res.dados.length
      this.pulseButton = res.dados.length > 0

      this.valueOsStopped = 0
      for (let dados of res?.dados) {
        this.valueOsStopped += dados.valor

      }
      this.valueOsStopped = this.conversaoLibraConverte.conversaoLibra(this.valueOsStopped, null, null)
      
      // Anima valor OS paradas
      setTimeout(() => {
        this.animateValue('valueOsStopped', this.valueOsStopped, 1000);
      }, 400);
    })
  }

  private getDealersServiceInative() {

    this.serviceClient.buscarServico('/status/servico', 0, 0).subscribe({
      next: (res) => {
        if (res.length > 0) {
          this.servicoDados = res;
          this.servicoDados.forEach(dealers => {
            if (dealers.status == "INATIVO") {
              this.dealersInativos = true;
            }
          });
        }
      },
      error: (_error) => {
        this.servicoDados = [];
      }
    });
  }

  private getTranslateChartLine() {
    this.translateService.onLangChange
      .subscribe((_event: TranslationChangeEvent) => {
        let labelTranslateChartDataSet;

        this.translateService
          .stream(this.arrayTranslateChartDataSet.map(item => item.chave))
          .subscribe(value => {

            labelTranslateChartDataSet = [];

            this.arrayTranslateChartDataSet.forEach(item => {
              labelTranslateChartDataSet.push(value[item.chave]);
            });
            this.chartQuantidadeAberturaOSData[0].label = labelTranslateChartDataSet[0];
            this.chartQuantidadeAberturaOSData[1].label = labelTranslateChartDataSet[1];
            this.chartValorAberturaOSData[0].label = labelTranslateChartDataSet[0];
            this.chartValorAberturaOSData[1].label = labelTranslateChartDataSet[1];

            this.chartQuantidadeFechamentoOSData[0].label = labelTranslateChartDataSet[0];
            this.chartQuantidadeFechamentoOSData[1].label = labelTranslateChartDataSet[1];
            this.chartValorFechamentoOSData[0].label = labelTranslateChartDataSet[0];
            this.chartValorFechamentoOSData[1].label = labelTranslateChartDataSet[1];
          }, error => console.log(error));
      });
  }


  goToVor() {
    this.router.navigate(['/pca/vor']);
  }

  goToStatusServico() {
    this.router.navigate(['/status/servico']);
  }

  // Função para animar valores
  animateValue(property: string, targetValue: number, duration: number = 1000) {
    const startValue = 0;
    const startTime = performance.now();
    
    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Função de easing para uma animação mais suave
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      
      this.animatedValues[property] = startValue + (targetValue - startValue) * easeOutQuart;
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        this.animatedValues[property] = targetValue;
      }
    };
    
    requestAnimationFrame(animate);
  }

  // Função para obter valor animado formatado
  getAnimatedValue(property: string): string {
    return this.formatarValorBrasileiro(this.animatedValues[property]);
  }

  // Função para formatação brasileira dos valores
  formatarValorBrasileiro = (valor: any): string => {
    if (valor === null || valor === undefined || valor === '' || isNaN(valor)) {
      return '0,00';
    }
    
    // Converte para string para verificar se tem ponto decimal
    let valorStr = valor.toString();
    
    // Se tem ponto decimal, substitui por vírgula e formata
    if (valorStr.includes('.')) {
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(parseFloat(valorStr));
    } else {
      // Se é número inteiro, formata como tal
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(parseInt(valorStr));
    }
  }

}
